(function() {
  if (window.lfmSearchHistoryReady) return;
  window.lfmSearchHistoryReady = true;

  var key = 'lfm_recent_searches_v1';
  var oldKey = 'lfm-recent-searches';
  var maxItems = 8;

  function read() {
    try {
      var oldValue = localStorage.getItem(oldKey);
      var current = localStorage.getItem(key);
      if (!current && oldValue) {
        localStorage.setItem(key, oldValue);
        localStorage.removeItem(oldKey);
      }
      var parsed = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(parsed) ? parsed.filter(Boolean).slice(0, maxItems) : [];
    } catch (error) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(key, JSON.stringify(items.slice(0, maxItems)));
    } catch (error) {
      return;
    }
  }

  function normalize(query) {
    return String(query || '').trim().replace(/\s+/g, ' ');
  }

  function save(query) {
    var clean = normalize(query);
    if (!clean) return read();
    var lower = clean.toLowerCase();
    var next = [clean].concat(read().filter(function(item) {
      return String(item).toLowerCase() !== lower;
    })).slice(0, maxItems);
    write(next);
    return next;
  }

  function remove(query) {
    var lower = String(query || '').toLowerCase();
    var next = read().filter(function(item) {
      return String(item).toLowerCase() !== lower;
    });
    write(next);
    return next;
  }

  function clear() {
    write([]);
    return [];
  }

  window.lfmSearchHistory = {
    read: read,
    save: save,
    remove: remove,
    clear: clear,
    normalize: normalize
  };
})();
